import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class FileService {
  private http = inject(HttpClient);


  upload(file: File, path: 'upload'): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.request(new HttpRequest('POST', `/api/${path}`, formData, { reportProgress: true, responseType: 'json' }));
  }

  getAll(dir: string): Observable<any[]> {
    return this.http.get<any[]>(`/api/files/${dir}`);
  }

  delete(file: string, dir: string): Observable<void> {
    return this.http.delete<void>(`/api/file/${file}/${dir}`);
  }

  getLog(log: string, lines: number): Observable<string> {
    return this.http.get<string>(`/api/logs/${log}/${lines}`);
  }

  clearLog(log: string): Observable<void> {
    return this.http.put<void>(`/api/logs/${log}/clear`, {});
  }

  getVersion(): Observable<string> {
    return this.http.get<string>('/api/version');
  }

}
